export default "__VITE_ASSET__uN101qwZ__"